import { Typography, Button } from "../../components"
import "./styles.css";

export default function AlgemeneVoorwaarden(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Algemene voorwaarden</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={'https://www.babyfeeding.nl/media/general/algemene-voorwaarden/nolia/deelnemers/document/digital.pdf'} 
                    text={`Voor deelnemers`}
                />
                <Button 
                    target='_blank' 
                    href={'https://www.babyfeeding.nl/media/general/algemene-voorwaarden/nolia/lactatiekundigen/document/digital.pdf'} 
                    text={`Voor lactatiekundigen`}
                /> 
                <Button 
                    target='_blank' 
                    href={'https://www.babyfeeding.nl/media/general/algemene-voorwaarden/academy/document/digital.pdf'} 
                    text={`Voor BabyFeeding Academy`}
                />  
            </div>
        </div>
    )
}